import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  Inject,
  Injector,
  LOCALE_ID,
  NgModule,
  provideAppInitializer,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StorageService } from 'api-base-refrence';
import { syncInject, SyncNg } from 'sync-engine';
import { AppComponent } from './app.component';
import { HttpClientService } from './util/service/http-client-service';
import { AppRoutingModule } from './app.routing';
import { RULE_PROVIDER_SERVICE } from 'casl-authorize';
import { RuleProviderService } from '../domains/authentication/app/service/rule-provider.service';
import {
  NestjsStatusResponseMapper,
  ResponsePipe,
  RESULT_PIPE_HANDLER,
  ResultPipeHandler,
  SANITIZE_SERVICE,
  SanitizeResponseService,
} from 'nestjs-model-utility';
import { AuthenticationRoute } from '../domains/authentication/authentication.route';
import { SiteManagmentRoute } from '../domains/site-managment/site-managment.route';

import { MsDebugToolsModule } from 'ms-debug-tools';
import { StatusCodeInterceptor } from 'status-interceptor';
import { FORBIDDEN_REDIRECT_ROUTE, LOGIN_ROUTE } from 'route-strategy';
import { SyncUpdateService } from 'sync-update';
import { DashboardComponent } from './component/dashboard-layout/dashboard.component';

import { MainPageLayoutComponent } from './component/main-page-layout/main-page-layout.component';
import { FullLayoutComponent } from './component/full-layout/full-layout.component';
import { appInjectorResolver } from './app.ref';
import {
  JWT_AUTH_TOKEN_SERVICE,
  JwtAuthModule,
  JwtAuthTokenService,
} from 'angular-jwt-auth';
import {
  HashLocationStrategy,
  LocationStrategy,
  registerLocaleData,
} from '@angular/common';

import { RouterModule } from '@angular/router';
import { BreadcrumbXngModule } from 'breadcrumb-xng';
import {
  BreadcrumbComponent,
  BreadcrumbItemDirective,
  BreadcrumbService,
} from 'xng-breadcrumb';

import { AccordionModule } from 'primeng/accordion';
import { ToastModule } from 'primeng/toast';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MessageService } from 'primeng/api';
import { NotificationService } from './util/service/notification.service';
import { ToastNotifModule, MessageServiceWrapper } from 'toast';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { LazyLoaderService } from 'lazy-loader-service';
import localeFa from '@angular/common/locales/fa';

registerLocaleData(localeFa, 'fa-IR');
import { MemoryStorageService } from 'src/domains/theme/requirements/memory-storage/storage-memory.service';
import { BehaviorSubject, filter, first, firstValueFrom, map, of } from 'rxjs';
import { CatchMaintenanceError } from 'catch-error';
import { requestResponseMapper } from 'nestjs-model-utility';
import { ConcurrentErrorHandlerModule } from 'concurrent-error-handler';
import { CatchErrorModule } from 'catch-error';
import { ENVIRONMENT } from 'model-utility';
import { environment } from 'src/environments/environment';
import { GetUrlService } from 'previous-url';
import { AppRoute } from './app.route';
import { MAINTENANCE_GUARD_CONFIG } from 'catch-error';
import { AppVerticalMenuComponent } from './component/app-vertical-menu/app-vertical-menu.component';
import { AppRouteStrategyGuard } from 'src/domains/authentication/app/service/app-authorization-guard';
import { LiveTrack } from 'live-track';
import { LoginRequest } from 'src/domains/authentication/model/login-auth/login.request';
import { SystemConfigRequest } from 'src/domains/site-managment/model/system-config/system-config.request';
import {
  DELETE_SESSION_API,
  GET_SYSTEM_CONFIG,
  TimeOutInterceptor,
} from 'timeout';
import { DependentApiUpdate } from './util/service/dependent-api-update.service';
import {
  BaseModalModule,
  BaseModalOptions,
  ModalWrapperService,
} from 'base-modal';
import { PrimengModalImporter } from 'src/domains/share/app/component/primeng-form-modal/primeng-modal.importer';
export const tokenProvider = (rt) => {
  return fetch('/api/session/access', {
    headers: {
      authorization: `Bearer ${rt}`,
    },
  }).then(async (response) => {
    const successRequest = 200 <= response.status && response.status < 300;
    if (!successRequest) {
      const body = await response.json();
      throw new Error(body?.message);
    }
    return response.json().then((body) => {
      return body?.data?.access;
    });
  });
};
@NgModule({
  declarations: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  // check new method for initial application
  bootstrap: [AppComponent],
  imports: [
    RouterModule,
    FullLayoutComponent,
    MainPageLayoutComponent,
    AppVerticalMenuComponent,
    DashboardComponent,
    BrowserModule,
    BrowserAnimationsModule,
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    JwtAuthModule.forRoot(tokenProvider),
    AccordionModule,
    ToastModule,
    MsDebugToolsModule,
    BreadcrumbXngModule,
    BreadcrumbComponent,
    BreadcrumbItemDirective,
    ToastNotifModule,
    BaseModalModule.forRoot(
      (param: {
        openModalEmitter: BehaviorSubject<BaseModalOptions>;
        closeModalEmitter: BehaviorSubject<boolean>;
        wrapperServiceInstance: ModalWrapperService;
        initWrapperEmitter: BehaviorSubject<boolean>;
      }) => {
        return new PrimengModalImporter(param);
      },
    ),
    ConcurrentErrorHandlerModule.forRoot({
      mapper: NestjsStatusResponseMapper,
    }),
    CatchErrorModule,
    // GoogleTagManagerModule.forRoot({
    //   id: 'GTM-KM9KGGB7',
    // }),
  ],
  providers: [
    {
      provide: ENVIRONMENT,
      useValue: environment,
    },
    provideAppInitializer(appInit()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    { provide: LOCALE_ID, useValue: 'fa-IR' },
    DependentApiUpdate,
    LazyLoaderService,
    HttpClientService,
    SyncUpdateService,
    MessageService,
    StorageService,
    MemoryStorageService,
    MessageServiceWrapper,
    GetUrlService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: StatusCodeInterceptor,
      multi: true,
    },
    {
      provide: RULE_PROVIDER_SERVICE,
      useClass: RuleProviderService,
      multi: false,
    },

    {
      provide: BreadcrumbService,
      useClass: BreadcrumbService,
      multi: false,
    },
    {
      provide: NotificationService,
    },
    {
      provide: LOGIN_ROUTE,
      useValue: AuthenticationRoute.map.full.authentication.root,
      multi: false,
    },
    {
      provide: FORBIDDEN_REDIRECT_ROUTE,
      useValue: SiteManagmentRoute.map.root,
      multi: false,
    },
    {
      provide: JWT_AUTH_TOKEN_SERVICE,
      useClass: JwtAuthTokenService,
      multi: false,
    },
    {
      provide: SANITIZE_SERVICE,
      useClass: SanitizeResponseService,
      multi: false,
    },
    {
      provide: RESULT_PIPE_HANDLER,
      useExisting: SANITIZE_SERVICE,
      multi: true,
    },
    {
      provide: RESULT_PIPE_HANDLER,
      useClass: DependentApiUpdate,
      multi: true,
    },
    {
      provide: MAINTENANCE_GUARD_CONFIG,
      useValue: {
        maintenancePath:
          SiteManagmentRoute.map.blank_layout.maintenance_mode.path,
        mainPagePath: AppRoute.map.site_managment.root.path,
      },
    },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimeOutInterceptor,
      multi: true,
    },
    {
      provide: DELETE_SESSION_API,
      useValue: () => {
        return new LoginRequest.Delete(undefined)
          .call()
          .pipe(first())
          .subscribe((data) => {
            if (data?.response?.statusCode === 200) {
              JwtAuthTokenService.clearToken();
              location.href = '/';
            }
          });
      },
      multi: false,
    },
    {
      provide: GET_SYSTEM_CONFIG,
      useValue: () => {
        return new SystemConfigRequest.List({
          limit: 100,
        })
          .call()
          .pipe(map((response) => response?.response?.data?.[0]?.configs));
      },
      multi: false,
    },
    provideAppInitializer(appInit()),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {
  @syncInject() syncNg: SyncNg;
  constructor(
    httpClientService: HttpClientService,
    storageService: StorageService,
    socketServic: SyncUpdateService,
    AppRouteStrategyGuard: AppRouteStrategyGuard,
    appInjector: Injector,
    MessageServiceWrapper: MessageServiceWrapper,
    getUrlService: GetUrlService,
    // private gtmService: GoogleTagManagerService,
    @Inject(RESULT_PIPE_HANDLER) private resultpipes: ResultPipeHandler[], // private gtmService: GoogleTagManagerService,
  ) {
    // this.gtmService.addGtmToDom();
    appInjectorResolver(appInjector);
    this.syncNg.sendRequestService$.next(httpClientService);
    this.syncNg.storeage$.next(storageService);

    ResponsePipe.pipes.push(...resultpipes);
  }
}
//add for just commit
export function appInit() {
  return async () => {
    try {
      const maintenanceService = inject(CatchMaintenanceError);
      const res = await fetch('/api/system-config?limit=100');
      await firstValueFrom(
        maintenanceService.handler(of(requestResponseMapper(res))),
      );

      const isAuthenticate = await firstValueFrom(
        JwtAuthTokenService.isAuthenticated$.pipe(
          filter((val) => typeof val === 'boolean'),
        ),
      );
      const liveTrack = new LiveTrack(2000);
      if (isAuthenticate) {
        const logout = await liveTrack.liveEnd;
        if (logout) {
          await firstValueFrom(new LoginRequest.Delete(undefined).call());
          JwtAuthTokenService.clearToken();
          window.location.href = '/';
          await new Promise(() => {
            // do nothing
          });
        }
      }
      return true;
    } catch (err) {
      console.error('Network error:', err);
      return true;
    }
  };
}
